import { RATING_SCALES, WORKFLOW_LIMITS, type RatingScale } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Segmented } from "@sagot/ui";
import type { AskRatingStep } from "../types";
import { CountedTextarea } from "./counted-field";
import { ExitsEditor } from "./exits-editor";
import type { FlowContext } from "./flow-context";
import { SwitchRow } from "./switch-row";
import { VariableList, type FormProps } from "./webhook-form";

const F = "engage.workflows.fields";

/** Ask for a rating: the question, stars or thumbs, an optional comment, and where a rating leads. */
export function AskRatingForm({ step, disabled, onChange, paths, canAddPath }: FormProps<AskRatingStep> & Pick<FlowContext, "paths" | "canAddPath">) {
  const { t } = useTranslation();
  return (
    <div className="space-y-5">
      <div>
        <CountedTextarea label={t(`${F}.ratingQuestion`)} hint={t(`${F}.ratingQuestionHint`)} rows={3} value={step.text} max={WORKFLOW_LIMITS.ratingText} disabled={disabled} onChange={(text) => { onChange({ ...step, text }); }} />
        <VariableList />
      </div>
      <div>
        <span className="label">{t(`${F}.ratingScale`)}</span>
        <Segmented
          aria-label={t(`${F}.ratingScale`)}
          value={step.scale}
          onValueChange={(scale: RatingScale) => { onChange({ ...step, scale }); }}
          options={RATING_SCALES.map((scale) => ({ value: scale, label: t(`${F}.ratingScales.${scale}`) }))}
        />
      </div>
      <SwitchRow label={t(`${F}.askComment`)} description={t(`${F}.askCommentHint`, { max: WORKFLOW_LIMITS.ratingComment })} checked={step.ask_comment} disabled={disabled} onChange={(ask_comment) => { onChange({ ...step, ask_comment }); }} />
      <ExitsEditor step={step} onChange={onChange} paths={paths} canAddPath={canAddPath} disabled={disabled} />
    </div>
  );
}
